var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWidgetMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 7.91c0 3.283-3.7 6.164-4.734 6.905a.451.451 0 0 1-.532 0C7.699 14.074 4 11.193 4 7.91c0-1.302.527-2.55 1.464-3.471A5.047 5.047 0 0 1 9 3c1.326 0 2.598.517 3.536 1.438A4.864 4.864 0 0 1 14 7.909z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 9.546c.92 0 1.666-.733 1.666-1.637 0-.903-.746-1.636-1.666-1.636-.92 0-1.667.733-1.667 1.636 0 .904.746 1.637 1.667 1.637z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWidgetMap);
export default __webpack_public_path__ + "static/media/widgetMap.2ab9f10943548324338ef660cbe848c5.svg";
export { ForwardRef as ReactComponent };